import { render, staticRenderFns } from "./ProductDetalisTop.vue?vue&type=template&id=6a224346&scoped=true&"
import script from "./ProductDetalisTop.vue?vue&type=script&lang=js&"
export * from "./ProductDetalisTop.vue?vue&type=script&lang=js&"
import style0 from "./ProductDetalisTop.vue?vue&type=style&index=0&id=6a224346&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a224346",
  null
  
)

export default component.exports